import {Brick, registerBrick, Service} from 'olympe';

export default class FakeOpenPR extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} frontendId
     * @param {function()} forwardEvent
     */
    update($, [frontendId], [forwardEvent]) {
        Service.publish('userService', ({frontendId: frontendId, openPrs: ['019808b78bf7a75e9eff'], updatedPr: '019808b78bf7a75e9eff'}))
            .then(() => {
                forwardEvent();
            })
            .catch((e) => {
                console.error(`Error while calling the service userService ${e}`);
            });
    }
}

registerBrick('0198ccaaa369730ea2f2', FakeOpenPR);
